import React, {
    useEffect, useRef, useState,
} from 'react'
import {TooltipProps} from './types'
import TooltipView from './TooltipView'

const Tooltip = (props: TooltipProps) => {
    const {
        id, verticalMargin = 0, horizontalMargin = 0, children, position = 'top',
    } = props

    const tooltipRef = useRef<HTMLDivElement>(null)

    const [tooltipVisible, setTooltipVisible] = useState(false)
    const [coordinates, setCoordinates] = useState({
        x: 0,
        y: verticalMargin,
    })

    useEffect(() => {
        const elem = document.querySelector(`[data-tooltip-id="${id}"]`)

        elem?.addEventListener('mouseover', () => {
            setTooltipVisible(true)
        })

        elem?.addEventListener('mouseleave', () => {
            setTooltipVisible(false)
        })
    }, [])


    useEffect(() => {
        if (tooltipVisible) {
            const elem: HTMLElement | null = document.querySelector(`[data-tooltip-id="${id}"]`)

            if (elem && tooltipRef?.current) {
                if (position === 'top') {
                    setCoordinates({
                    // eslint-disable-next-line no-extra-parens
                        x: (elem.offsetLeft - (tooltipRef.current.clientWidth / 2) + (elem.clientWidth / 2)),
                        y: verticalMargin + elem.offsetTop - tooltipRef.current.clientHeight,
                    })
                } else if (position === 'right') {
                    setCoordinates({
                        // eslint-disable-next-line no-extra-parens
                        x: elem.offsetLeft + elem.clientWidth + horizontalMargin,
                        // eslint-disable-next-line no-extra-parens
                        y: (elem.offsetTop - (tooltipRef.current.clientHeight / 2) + (elem.clientHeight / 2)),
                    })
                }
            }
        }
    }, [tooltipVisible, children])


    return <TooltipView coordinates={coordinates} ref={tooltipRef} tooltipVisible={tooltipVisible} {...props} />
}

Tooltip.defaultProps = {
    singleLine: false,
    width: 'auto',
}

export default Tooltip
